import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@pw-utils/services/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class AfterLoginPathGuard  {
  constructor(private _auth: AuthService, private _router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const afterLoginPath = this._auth.getAfterLoginPath();
    this._auth.deleteAfterLoginPath();
    return !!route.fragment || !afterLoginPath || this._router.parseUrl(`${state.url}#${afterLoginPath}`);
  }
}
